module.exports = __webpack_public_path__ + "static/SM_oct26_good-f66dcfae9d3889af0677dfbb15c78b21.svg";